
import { defineComponent, reactive } from 'vue'

// components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

export default defineComponent({
    components: {
        TheButton,
        TheSelect,
        TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const filters_state = reactive({
            email: null as string | null,
            name: null as string | null,
            source: null as number | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
        })

        const reset = () => {
            if (props.loading) return

            filters_state.email = null
            filters_state.name = null
            filters_state.source = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', { ...filters_state })
        }

        return {
            filters_state,
            reset,
            search,
        }
    },
})
